module.exports = __webpack_public_path__ + "img/h1-1.4ccd97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/h1-1.png
// module id = Rnt+
// module chunks = 15